export default __webpack_public_path__ + "static/media/image.b1a99ef6.png";